
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Colorectal_carcinoma",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Colorectal_carcinoma.vue